import React, { useEffect, useState } from 'react'
import { supabase } from 'utils/supabase'
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import { SuccessCandidateTypes } from 'admin/components/SuccessCandidateForm'
import CandidatePreview from 'admin/components/CandidatePreview'

const NomineePreview = () => {
  const [candidate, setCandidate] = useState<SuccessCandidateTypes | null>(null)
  const { id } = useParams()
  const navigate = useNavigate()

  const fetchCandidate = async () => {
    try {
      const response = await supabase.from('candidates').select().eq('id', id)
      const data = response.data ? response.data[0] : null

      if (data) {
        setCandidate(data)
      }
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    fetchCandidate()
  }, [id])

  return (
    <Wrapper>
      <CandidatePreview candidate={candidate} />
    </Wrapper>
  )
}

export default NomineePreview

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 60%;
`
